import { defineComponent as _defineComponent } from 'vue'
import {desanitizeString} from "@/utils/Helpers";
import {PrintRecipeDetails} from "@/models/Recipes/PrintRecipeDetails";
import {DishRecipeCommon} from "@/models/DishRecipeCommon";
import {RecipeCompositionMeasurement} from "@/models/Recipes/RecipeCompositionMeasurement";
import {RecipeIngredient} from "@/models/Recipes/RecipeIngredient";


export default /*#__PURE__*/_defineComponent({
  __name: 'vRecipeNutritionLabelPrintout',
  props: {
    recipe: null,
    printMeta: null,
    subrecipeServingSizes: null,
    ingredients: { default: () => [] },
    imageUrl: null
  },
  setup(__props: any) {

const props = __props as { recipe: DishRecipeCommon, printMeta: PrintRecipeDetails, subrecipeServingSizes: RecipeCompositionMeasurement[], ingredients: RecipeIngredient[], imageUrl: string };



function getSubrecipeMeasurementByCompositionMeasurementId(compositionMeasurementId: number) {
  return props.subrecipeServingSizes.find(
    (rcm: RecipeCompositionMeasurement) => rcm.id === compositionMeasurementId
  )!.measurement;
}

return { __sfc: true,props, getSubrecipeMeasurementByCompositionMeasurementId, desanitizeString }
}

})